import { SQUARE_ASPECTS_STRING } from '@anm/data/aspects';

import { TemplatePage } from './types';

const industryPage: TemplatePage = {
  header: {
    color: '#FED174',
    icon: 'images/video-templates/industries.jpg',
    title: 'Industries video templates',
    title_meta: '500+ Customizable Industry Video Templates',
    description_meta:
      'Save time and effort when making engaging video content with Wave.video’s collections of editable video templates ' +
      'for any industry.',
    description:
      'Save time and effort when making engaging video content with Wave.video’s collections of editable video templates for ' +
      'any industry. Easy-to-customize and free!'
  },
  footer: {
    category: 'industry',
    description:
      'With Wave.video’s collections of editable video templates for various industries, you won’t need to hire a high-end ' +
      'graphic designer to make catchy video content for your niche. Just pick a template that suits your needs best, customize ' +
      'it to your branding, and download or share directly on social media. Easy as one-two-three!'
  },
  content: [
    {
      type: 'slider',
      title: 'Architecture and design',
      name: 'industry-architecture-and-design',
      search: {
        category: '/Industries/Interior Design',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Art and culture videos',
      name: 'industry-art-and-culture',
      search: {
        category: '/Industries/Art & Culture',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Beauty & care videos',
      name: 'industry-beauty',
      search: {
        category: '/Industries/Fashion & Beauty',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Business templates',
      name: 'industry-business',
      search: {
        category: '/Industries/Business',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'E-commerce & retail templates',
      name: 'industry-e-commerce',
      search: {
        category: '/Industries/eCommerce',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Education',
      name: 'industry-education',
      search: {
        category: '/Industries/Education',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Entertainment',
      name: 'industry-entertainment',
      search: {
        category: '/Use Cases/Entertainment',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Fasion',
      name: 'industry-fashion',
      search: {
        category: '/Industries/Fashion & Beauty',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Food',
      name: 'industry-food',
      search: {
        category: '/Industries/Restaurants & Food',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Lifestyle',
      name: 'industry-lifestyle',
      search: {
        category: '/Industries/Lifestyle',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Marketing',
      name: 'industry-marketing',
      search: { name: 'marketing', aspects: SQUARE_ASPECTS_STRING }
    },
    {
      type: 'slider',
      title: 'Music',
      name: 'industry-music',
      search: { name: 'music', tags: 'music', aspects: SQUARE_ASPECTS_STRING }
    },
    {
      type: 'slider',
      title: 'Nature',
      name: 'industry-nature',
      search: {
        category: '/Industries/Nature & Environment',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Pets',
      name: 'industry-pets',
      search: { category: '/Industries/Pets', aspects: SQUARE_ASPECTS_STRING }
    },
    {
      type: 'slider',
      title: 'Real estate',
      name: 'industry-real-estate',
      search: {
        category: '/Industries/Real Estate',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Sport and fitness',
      name: 'industry-sports-and-fitness',
      search: {
        category: '/Industries/Sport & Wellness',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Technology and computers',
      name: 'industry-technology',
      search: {
        category: '/Industries/Technology',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Travel',
      name: 'industry-travel',
      search: { category: '/Industries/Travel', aspects: SQUARE_ASPECTS_STRING }
    },
    {
      type: 'stocks',
      title: 'industries',
      search: { name: 'industry' }
    },
    {
      type: 'calendar'
    }
  ]
};

export default industryPage;
